export default "__VITE_ASSET__BLP_nfNn__"